import { isRejectedWithValue, Middleware } from '@reduxjs/toolkit';

import { setSessionExpired } from './liffUser';

interface RTKQueryError {
  status?: number;
  originalStatus?: number;
}

/**
 * セッションエラーを検知するReduxミドルウェア
 *
 * このミドルウェアは全てのRTK Queryのエラーレスポンスを監視し、
 * 401エラー（Forbidden）を検知した場合にセッション切れとして処理します。
 *
 * 対象となるAPIエンドポイント（Bearer認証を使用する全てのエンドポイント）:
 * - GET /profile（ユーザーデータ取得）
 * - POST /profile（ユーザーデータ送信）
 * - PUT /profile（プロフィール更新）
 * - POST /keyword（キーワード送信）
 * - POST /reward（報酬データ送信）
 * - POST /clear-card（クリアカード送信）
 * - POST /clue（ヒントデータ送信）
 * - GET /progress（進捗データ取得）
 * - POST /complete-onboarding（オンボーディング完了）
 * - GET /prize（賞品データ取得）
 * - POST /prize（賞品データ送信）
 *
 * 動作フロー:
 * 1. RTK Queryのアクションがrejectされた場合をキャッチ
 * 2. エラーペイロードから401ステータスを検出
 * 3. setSessionExpiredアクションをdispatchしてセッション切れ状態を設定
 * 4. Layout.tsxでダイアログが表示される
 */
export const sessionErrorMiddleware: Middleware = storeApi => next => action => {
  // RTK Queryのエラーアクションをチェック
  if (isRejectedWithValue(action)) {
    const error = action.payload;

    // エラーオブジェクトの存在確認
    if (error && typeof error === 'object') {
      const rtkError = error as RTKQueryError;
      // RTK Queryは status または originalStatus にHTTPステータスコードを格納
      const status = rtkError.status || rtkError.originalStatus;

      // 401 Forbiddenの場合、JWTトークンが無効または期限切れと判断
      if (status === 401) {
        // セッション切れ状態をRedux storeに設定
        storeApi.dispatch(setSessionExpired());
      }
    }
  }

  // 次のミドルウェアまたはリデューサーにアクションを渡す
  return next(action);
};
